import React, { useEffect, useState } from 'react'
import { Row, Col, Table, Button } from 'react-bootstrap'
import { ModalComponent } from '../presentational-components/ModalComponent'
import NewB2COrder from './NewB2COrder'
import PayProcessB2COrder from './PayProcessB2COrder'
import { ContactDetails } from './ContactDetails'
import { FetchBoutiqueInfos, FetchSalutations } from '../../fetcher'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import AlertMessage from '../presentational-components/AlertMessage'
import { RenderImage } from '../presentational-components/ImageViewer'
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment'
//import 'moment/locale/de'
//moment.locale('de')

const B2COrderTransaction = ({ setNewB2CTransaction, reload }) => {

    console.log("NewB2CTransaction");

    const [date, setDate] = useState(new Date())
    const boutique = "Boutique"
    //const [payment, setPayment] = useState(null)
    const [number, setNumber] = useState(0)
    const [total, setTotal] = useState(0)

    const [paymentList, setPaymentList] = useState([])
    const [designerList, setDesignerList] = useState([])
    const [salutations, setSalutations] = useState([])

    const [transactions, setTransactions] = useState([])
    const [contactIsSet, setContactIsSet] = useState(false)
    const [contactDetails, setContactDetails] = useState({ Contact: {} })

    const [newBooking, setNewBooking] = useState(false)
    const [payProcess, setPayProcess] = useState(false)
    const [openContactDetails, setOpenContactDetails] = useState(false)

    const [articleDataReady, setArticleDataToReady] = useState(false)
    const [showAlertMessage, setShowAlert] = useState(false)
    const openAlert = () => {
        setShowAlert(true)
    }
    const closeAlert = () => {
        setShowAlert(false)
    }

    const setBoutiqueInfos = (boutiqueInfos) => {
        setPaymentList(boutiqueInfos.Payments)
        setDesignerList(boutiqueInfos.Designer)
        //setArticleTypesList(boutiqueInfos.ArticleTypes)

        //console.log("BoutiqueInfos set")
        //setArticleDataToReady(true)
    }

    useEffect(() => {
        FetchBoutiqueInfos(setBoutiqueInfos, openAlert, setArticleDataToReady)
    }, []);

    useEffect(() => {
        FetchSalutations(setSalutations, openAlert)
        console.log("Salutations ", salutations)
    }, []);

    const addTransaction = (newTransaction) => {
        const transactionsCopy = [...transactions]
        console.log("NewTransaction ArticleTypeSysId: ")
        console.log(newTransaction.articleType.ArticleTypeSysId)

        const oldTransaction = transactionsCopy.find(x => x.articleType.ArticleTypeSysId == newTransaction.articleType.ArticleTypeSysId && x.size.Size == newTransaction.size.Size)
        if (oldTransaction !== null && oldTransaction !== undefined) {
            let oldAmount = parseInt(oldTransaction.number)
            let newAmount = parseInt(newTransaction.number)
            oldTransaction.number = oldAmount + newAmount
            oldTransaction.remarks = newTransaction.remarks
            oldTransaction.total = (oldAmount + newAmount) * parseFloat(newTransaction.total)//oldTransaction.total + newTransaction.total
            oldTransaction.discount = newTransaction.discount

        } else {
            transactionsCopy.push(newTransaction)
        }

        setTransactions(transactionsCopy)
        console.log("Added Transaction: ")
        console.log(transactionsCopy)
        const newTotal = transactionsCopy.map(x => x.total).reduce((a, b) => a + b)
        console.log("setTotal" + newTotal)
        setTotal(newTotal)
        setNumber(transactionsCopy.map(x => parseInt(x.number)).reduce((a, b) => a + b))
    }

    const removeTransaction = (event, transactionToBeRemoved) => {
        event.preventDefault()

        const transactionsCopy = [...transactions]
        var index = transactionsCopy.indexOf(transactionToBeRemoved)
        transactionsCopy.splice(index, 1)

        setTransactions(transactionsCopy)
        const newTotal = transactionsCopy.length > 0 ? transactionsCopy.map(x => x.total).reduce((a, b) => a + b) : 0
        setTotal(newTotal)
        setNumber(transactionsCopy.length)
    }

    if (newBooking === true) {
        return (<NewB2COrder addTransaction={addTransaction} setNewBooking={setNewBooking} designerList={designerList} date={date} openAlert={openAlert} />)
    } else if (openContactDetails === true) {
        console.log("ContactDetails Salutation ", salutations)
        return (<ContactDetails setOpenContactDetails={setOpenContactDetails} setContactDetails={setContactDetails} openAlert={openAlert} contactIsSet={contactIsSet} setContactIsSet={setContactIsSet} contactDetails={contactDetails} />)
    } else {

        return (
            <div>
                <h1 className="tablet-center">Neue Bestellung</h1>
                <div className="flex-linebreak"></div>

                <div className="tablet-transactions">
                    <Table>
                        <thead>
                            <tr>
                                <th>
                                    {moment(date).format("DD.MM.YYYY")}
                                    &nbsp;
                                    <DateRangePicker
                                        initialSettings={{
                                            singleDatePicker: true,
                                            startDate: Date.now,
                                            locale: {
                                                cancelLabel: 'Abbrechen',
                                                applyLabel: 'Ok'
                                            },
                                            minYear: 2000,
                                            maxYear: parseInt(moment().format('YYYY'), 10),
                                        }} onCallback={(manualDate) => setDate(manualDate)}>
                                        <Button variant="secondary" size="sm">
                                            Manuelles Datum
                                        </Button>
                                    </DateRangePicker>
                                    {/*<Button variant="secondary" size="sm" onClick={() => setManualDate()}>Manuelles Datum</Button>*/}
                                </th>
                                {/*<th><DateRangePicker /></th>*/}
                                {/*<th>{boutique}</th>*/}
                                {/*<th>{payment !== null ? payment : "Zahlung"}</th>*/}
                                <th>{number !== 0 ? number : "Anzahl"}</th>
                                <th>{parseFloat(total).toFixed(2).replace('.', ',') + "€"}</th>
                            </tr>
                            <tr>
                                <th>Ausgewählter Kunde: </th>
                                <th>{contactDetails.Contact.Name !== null && contactDetails.Contact.Name !== undefined ? contactDetails.Contact.Name + ", " + contactDetails.Contact.Surname : ""}</th>
                                <th>{contactDetails.Contact.Email ?? ""}</th>
                                <th>{contactDetails.Contact.Phone ?? ""}</th>
                                <th>{contactDetails.Street !== undefined && contactDetails.Street !== null ? (contactDetails.Street ?? "") + ", " + (contactDetails.HouseNumber ?? "") + ", " + (contactDetails.PostalCode ?? "") + ", " + (contactDetails.City ?? "") : ""}</th>
                            </tr>
                        </thead>
                    </Table>

                    <Row>
                        <div className="saleTransactionButtons">
                            <Col><Button variant="secondary" onClick={() => setNewBooking(true)}>Hinzufügen</Button></Col>
                            <Col><Button variant="secondary" disabled={transactions.length === 0 ? true : false} onClick={() => setOpenContactDetails(true)}>Kunde</Button></Col>
                            <Col><Button variant="secondary" disabled={(transactions.length === 0 || Object.entries(contactDetails).length == 0) ? true : false} onClick={() => setPayProcess(true)}>Zahlen</Button></Col>
                            <Col><Button variant="secondary" onClick={() => setNewB2CTransaction(false)}>Abbrechen</Button></Col>
                        </div>

                        <Col className="tablet-transactions-sale">
                            <Table className="nostriped table-sm table-striped-immediate">
                                <thead>
                                    <tr>
                                        <th>Ansicht</th>
                                        <th>Designername</th>
                                        <th>Artikelnr.</th>
                                        <th>Artikeltyp</th>
                                        <th>Größe</th>
                                        <th>Farbe</th>
                                        <th>Anzahl</th>
                                        <th>Einzelpreis</th>
                                        <th>Preisänderung</th>
                                        {<th>Anzahlung pro Artikel</th>}
                                        <th>Zu zahlen</th>
                                        <th>Bemerkung</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {transactions.map(transaction =>
                                        <tr>
                                            <td>{RenderImage(transaction.articleType.Image)}</td>
                                            <td>{transaction.designer.DesignerName}</td>
                                            <td>{transaction.articleType.ArticleIdFaex}</td>
                                            <td>{transaction.articleType.ArticleTypeName}</td>
                                            <td>{transaction.size.Size}</td>
                                            <td>{transaction.articleType.Colour}</td>
                                            <td className="numberColumn">{transaction.number}</td>
                                            <td className="numberColumn">{parseFloat(transaction.articleType.PriceUnit).toFixed(2).replace('.', ',') + "€"}</td>
                                            <td className="numberColumn">{parseFloat(transaction.priceChange).toFixed(2).replace('.', ',') + "€"}</td>
                                            <td className="numberColumn">{parseFloat(transaction.prepayment).toFixed(2).replace('.', ',') + "€"}</td>
                                            <td className="numberColumn">{parseFloat(transaction.total).toFixed(2).replace('.', ',') + "€"}</td>
                                            <td>{transaction.remarks.length < 50 ? transaction.remarks : transaction.remarks.substring(0, 44) + '...'}</td>
                                            <td className="remove-order-td">
                                                <a className="remove-order" href="" onClick={(event) => removeTransaction(event, transaction)} variant="secondary">&#10060;</a>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </div>
                <ModalComponent handleShow={payProcess} handleClose={() => setPayProcess(false)} formTitle="boutique-payprocess-form"
                    modalTitle="Buchung abschließen" modalBody={<PayProcessB2COrder paymentList={paymentList} transactions={transactions} contactDetails={contactDetails} date={date} handleClose={() => setPayProcess(false)} handleRedirect={() => setNewB2CTransaction(false)} reload={reload} openAlert={openAlert} />} />

                <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} />
            </div>
        )
    }
}

export default B2COrderTransaction